export default __webpack_public_path__ + "d93a40767715ea66114eec56a56fb17f.svg";